import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Fieldset from "../../components/common/Fieldset";
import AutoComplete from "../../components/common/AutoComplete";
import SelectInput from "../../components/common/SelectInput";
import Row from "../../components/common/Row";
import Loader from "../../components/common/Loader";
import AutoBindComponent from "../common/AutoBindComponent";
import adresApi from "../../api/adresApi";
import * as ajaxActions from "../../actions/ajaxCounterActions";

class AdresFieldset extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, false);

        this.state = {
            model: {
                huisnummer: null,
                busnummer: null
            },
            straatId: null,
            huisnummers: [],
            busnummers: [],
            huisnummersLoading: false,
            busnunmmersLoading: false
        };
    }

    componentDidMount = () => {
        // this.loadHuisnummer();
    };

    //unused for now, will be relevant in the future
    loadHuisnummer = () => {
        this.setState({ huisnummersLoading: true });
        setTimeout(() => {
            adresApi.getHuisnummers(this.state.straatId)
                .then((response) => {
                    this.setState({ huisnummersLoading: false });
                    this.setState({
                        huisnummers: response.data.map(e => { return { label: e.huisnummer, value: e.huisnummerId }; })
                    });
                })
                .catch((ex) => {
                    alert("getHuisnummers Error");
                });
        }, 3000);
    };

    //unused for now, will be relevant in the future
    loadBusnummer = () => {
        this.setState({ busnummersLoading: true });
        setTimeout(() => {
            adresApi.getBusnummers(this.state.model.huisnummer)
                .then((response) => {
                    this.setState({ busnummersLoading: false });
                    this.setState({
                        busnummers: response.data.map(e => { return { label: e.busnummer, value: e.busnummerId }; })
                    });
                })
                .catch((ex) => {
                    alert("getBusnummers Error");
                });
        }, 3000);
    };

    change = (event) => {
        const value = event.target.value;
        const property = event.target.name;

        const model = this.state.model;
        model[property] = value;

        this.setState({
            model
        });

        // if (property === "huisnummer")
        //     this.loadBusnummer();
    };

    render() {
        return (
            <Fieldset title="Adres">
                <Row>
                    Huisnummers loading: {this.state.huisnummersLoading ? "YES" : "NO"}
                    {this.state.huisnummersLoading ? <Loader /> : null}
                    <AutoComplete
                        items={this.state.huisnummers}
                        size={6}
                        name="huisnummer"
                        label="Huisnummer"
                        value={this.state.huisnummer}
                        onChange={this.change}
                        disabled={!this.state.huisnummers || !this.state.huisnummers.length}
                        isLoading={this.state.huisnummersLoading}
                    />
                </Row>
                <Row>
                    Busnummers loading: {this.state.busnummersLoading ? "YES" : "NO"}
                    {this.state.busnummersLoading ? <Loader /> : null}
                    <AutoComplete
                        items={this.state.busnummers}
                        size={6}
                        name="busnummer"
                        label="Busnummer"
                        value={this.state.busnummer}
                        onChange={this.change}
                        disabled={!this.state.model.huisnummer || !this.state.busnummers || !this.state.busnummers.length}
                        isLoading={this.state.busnummersLoading}
                    />
                </Row>
            </Fieldset>
        );
    }
}

AdresFieldset.defaultProps = {
};

AdresFieldset.propTypes = {
};

export default AdresFieldset;